import * as React from "react"
import { useRoute, Link } from "wouter"
import {
  InternalLinkNode,
  ExternalLinkNode,
  NodeKind,
  ReferenceLinkNode,
} from "blog/json_nodes"
import { Value } from "blog/components/json_lego"

export const ExternalLink = (props: { link: ExternalLinkNode }) => {
  const { url, label } = props.link
  return (
    <span className="Link ExternalLink">
      <Value>
        <a href={url}>{label}</a>
      </Value>
    </span>
  )
}

export const InternalLink = (props: { link: InternalLinkNode }) => {
  const { url, label } = props.link
  const [isActive] = useRoute(url)
  return (
    <span className="Link InternalLink">
      <Value>
        <Link href={url}>
          <a className={isActive ? "active" : ""}>{label}</a>
        </Link>
      </Value>
    </span>
  )
}

export const ReferenceLink = (props: { link: ReferenceLinkNode }) => {
  const { url, label, author, authorUrl } = props.link
  return (
    <span className="Link ReferenceLink">
      <Value>
        <Link href={url}>{label}</Link> by{" "}
        <Link href={authorUrl}>{author}</Link>
      </Value>
    </span>
  )
}

export function createExternalLink(
  label: string,
  url: string,
): ExternalLinkNode {
  return {
    kind: NodeKind.EXTERNAL_LINK,
    url,
    label,
  }
}

export function createInternalLink(
  path: string,
  label: string,
): InternalLinkNode {
  return {
    kind: NodeKind.INTERNAL_LINK,
    url: path,
    label,
  }
}

export function createReferenceLink(
  url: string,
  label: string,
  author: string,
  authorUrl: string,
): ReferenceLinkNode {
  return {
    kind: NodeKind.REFERENCE_LINK,
    url,
    label,
    author,
    authorUrl,
  }
}
